import Interaction from "../../../models/interactions/Interaction";
import { IHideLetterBox } from "../../../models/interactions/HideLetterBox";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import NodeNumberField from "../components/NodeNumberField";

export default function HideLetterBoxNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const hideLetterBox = props.interaction as IHideLetterBox;
  const { updateInteraction } = useUpdateSequenceInteraction();

  const animationTimeInput = (
    <NodeNumberField
      label="Animation Time"
      value={hideLetterBox.animationTime}
      onChange={(animationTime: number) =>
        updateInteraction(props.nodeId, {
          ...hideLetterBox,
          animationTime: animationTime,
        } as IHideLetterBox)
      }
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {animationTimeInput}
    </div>
  );
}
